import { FormControlLabel, Radio } from "@mui/material";
import { useEffect } from "react";
import {useFormContext, useWatch} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { useRatePlanQueryObserver } from "../../../../../api/services";
import { FormRadioGroup } from "../../../../../components/fields";
import { stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";

const FormMileageIncluded = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);

    const formContext = useFormContext<IFormValues>();

    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenants" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealers" });

    const ratePlanQuery = useRatePlanQueryObserver({tenant: tenant as string, dealer: dealer as string});

    useEffect(() => {
        if (step === InsertBookingStep.AVAILABILITY_PRICE) {
            if (
                ratePlanQuery.data &&
                ratePlanQuery.data.mileageList.length > 0
            ) {
                if (!ratePlanQuery.data.mileageList.find(m => m.value === formContext.getValues('basicDetails.mileageIncluded'))) {
                    formContext.setValue('basicDetails.mileageIncluded', ratePlanQuery.data.mileageList[0].value);
                }
            }
            else {
                formContext.setValue('basicDetails.mileageIncluded', null);
            }
        }
    }, [ratePlanQuery.data]);

    if (!ratePlanQuery.data) {
        return null;
    }

    return (
        <FormRadioGroup<IFormValues>
            name="basicDetails.mileageIncluded"
            label={t('label.mileageIncluded')}
        >
            {ratePlanQuery.data.mileageList.map(m => (
                <FormControlLabel
                    key={m.value}
                    value={m.value}
                    label={(m.value === '0KM' || m.value === '0') ? 'UNLIMITED' : m.value}
                    control={<Radio disabled={step === InsertBookingStep.CUSTOMER_DETAILS} />}
                />
            ))}
        </FormRadioGroup >
    );

};

export default FormMileageIncluded;
